import {ICreateStudentRequest, IGetResult, IUser} from "@/types/api";
import {API_URLS} from "@/utils/constants/api-urls";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";

export class UserService {

  static getInstance(): UserService {
    return new UserService();
  }

  async updateUser(user: IUser) {
    const {execute,data} = useAxios<IGetResult>(API_URLS.users.updateById(user._id), {
      method: "PATCH",
      data: user
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }
  async createStudent(body: ICreateStudentRequest) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.users.create, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data;
  }
}